export const EMPTY_TEXT = `Подходящих результатов не найдено. Пожалуйста, измените условия фильтрации.`;
